var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11523 12.1855C5.11523 10.798 5.11523 10.1043 5.54628 9.67323C5.97732 9.24219 6.67107 9.24219 8.05858 9.24219H24.1434C24.9145 9.24219 25.3001 9.24219 25.6255 9.41632C25.9508 9.59046 26.1647 9.91126 26.5924 10.5529L30.5169 16.4396C31.0445 17.2309 31.3083 17.6266 31.3083 18.0722C31.3083 18.5178 31.0445 18.9135 30.5169 19.7049L26.5924 25.5916C26.1647 26.2332 25.9508 26.554 25.6255 26.7281C25.3001 26.9023 24.9145 26.9023 24.1434 26.9023H8.05858C6.67107 26.9023 5.97732 26.9023 5.54628 26.4712C5.11523 26.0402 5.11523 25.3464 5.11523 23.9589V12.1855Z",
    stroke: "#F9F9F9",
    strokeWidth: 2.94335
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7764,
    cy: 18.0723,
    r: 1.47167,
    fill: "#F9F9F9",
    stroke: "#F9F9F9",
    strokeWidth: 2.94335
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.680c70bd4e7be09ee091f9df50995b36.svg";
export { ForwardRef as ReactComponent };